import React from 'react';
import { convertNodeToElement } from 'react-html-parser';

export default {
  decodeEntities: true,
  transform: function transform(node, index) {

    if (node.type === 'tag' && node.name === 'meta' && node.attribs.name === 'description') {
        node.attribs.class = 'swiftype';
        node.attribs['data-type'] = 'string';
        return convertNodeToElement(node, index, transform);
    }
    //if (node.type === 'tag' && node.name === 'meta' && node.attribs.property === 'og:title') {
    //    node.attribs.class = 'swiftype';
    //    node.attribs['data-type'] = 'string';
    //    node.attribs['name'] = 'title';
    //    return convertNodeToElement(node, index, transform);
    //}

  }
};